export default __webpack_public_path__ + "static/media/ic_add_to_cart.49cac78d.svg";